enum Path {
  Exam = '/questionnaire/exam',
  Score = '/questionnaire/score',
}

export default Path